import Script from 'next/script';

export default function JsonLD() {
  /* <!-- Schema.org --> */
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Physician',
    name: 'Dott.ssa Angela Formisano | Fisioterapista Ercolano',
    image: '/images/fisioterapista-angela-formisano.png',
    telephone: '+393394211017',
    url: 'https://angelaformisano.it',
    address: {
      '@context': 'https://schema.org',
      '@type': 'PostalAddress',
      streetAddress: 'Via Nicolò Marcello Venuti 69',
      addressLocality: 'Ercolano',
      postalCode: '80056',
      addressRegion: 'NA',
      addressCountry: 'IT',
    },
    medicalSpecialty: 'Physiotherapy',
    iso6523: 'IT:PIVA-09595981219',
  };
  return (
    <Script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}
